import React from "react";
import ExcoKecamatan from "../../components/organism/ExcoKecamatan";

const PageExcoKecamatan = () => {
  return (
    <>
      <ExcoKecamatan />
    </>
  );
};

export default PageExcoKecamatan;
